import { useState, useEffect } from 'react';

export default function Logo({ 
  size = 'md', 
  variant = 'square', 
  theme = 'auto',
  className = '' 
}) {
  const [logoSrc, setLogoSrc] = useState('');
  const [loading, setLoading] = useState(true);

  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-10 w-10',
    xl: 'h-12 w-12',
    '2xl': 'h-16 w-16',
    '3xl': 'h-20 w-20',
    'horizontal-lg': 'h-12 w-auto max-w-[200px]',
    'horizontal-xl': 'h-16 w-auto max-w-[180px]'
  };

  // Choose logo filename based on variant and theme
  const getLogoFilename = () => {
    if (variant === 'horizontal') {
      if (theme === 'dark') return 'logo-horizontal-dark.png';
      if (theme === 'bw') return 'logo-horizontal-bw.png';
      return 'logo1-horizontal-transparent.png';
    }
    
    if (variant === 'icon') {
      if (theme === 'transparent') return 'icon-transparent.png';
      return 'icon-original.png';
    }
    
    // Default to square logos
    if (theme === 'transparent') return 'logo-square-transparent.png';
    return 'logo-square.png';
  };

  useEffect(() => {
    async function loadLogo() {
      const filename = getLogoFilename();
      
      // Web app: Use public path directly
      setLogoSrc(`/${filename}`);
      setLoading(false);
    }

    loadLogo();
  }, [variant, theme]);

  if (loading) {
    return (
      <div className={`${sizes[size]} ${className} bg-slate-200 animate-pulse rounded`} />
    );
  }

  if (!logoSrc) {
    // Fallback to text logo if image fails to load
    return (
      <div className={`${sizes[size]} ${className} bg-blue-600 text-white rounded flex items-center justify-center font-bold text-xs`}>
        ZB
      </div>
    );
  }

  return (
    <img
      src={logoSrc}
      alt="ZyloBill Logo"
      className={`${sizes[size]} ${className} object-contain`}
      onError={() => setLogoSrc('')}
    />
  );
}